import Button from '../Button/Button';
import { ButtonMode } from '../Button/button-mode.enum';
import React from 'react';
import { useTranslationByKey } from 'src/hooks/use-translation-by-key';

const StaleProjectsPage: React.FC<{ onClick: () => void }> = ({ onClick }) => {
  const t = useTranslationByKey('PAGES.STALE_PROJECTS_PAGE');

  return (
    <div className="flex flex-col items-center justify-center flex-1 h-screen text-center gap-1">
      <h1 className="hidden md:block text-4xl text-content-neutral-main-enabled whitespace-pre-line pb-2">
        {t('ITS_BEEN_A_WHILE')}
      </h1>
      <h2 className="block md:hidden text-3xl text-content-neutral-main-enabled whitespace-pre-line pb-1 md:pb-0">
        {t('ITS_BEEN_A_WHILE')}
      </h2>

      <p className="text-body-p2 font-regular text-content-neutral-subtle-enabled whitespace-pre-line md:pb-9 pb-2">
        {t('SUBTITLE')}
      </p>

      <Button label={t('BUTTON_TITLE')} mode={ButtonMode.OnLight} onClick={onClick} />
    </div>
  );
};

export default StaleProjectsPage;
